import type {
    SelectCommerceCheckoutSavedPaymentMethodRequest,
    SelectCommerceCheckoutSavedPaymentMethodResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const selectCommerceCheckoutSavedPaymentMethodOperation = defineCommerceOperation<
    SelectCommerceCheckoutSavedPaymentMethodRequest,
    SelectCommerceCheckoutSavedPaymentMethodResponse
>("commerce.checkout.payment-method.select");
